import {CopyToClipboardIconButton} from '@github-ui/copy-to-clipboard/IconButton'
import {LinkIcon} from '@primer/octicons-react'

import type {PanelArtifact} from './ArtifactPanelContent'

export function ArtifactCopyLinkButton({artifact}: {artifact: PanelArtifact | null}) {
  if (!artifact?.htmlUrl) return null

  return <CopyToClipboardIconButton icon={LinkIcon} textToCopy={artifact.htmlUrl} ariaLabel="Copy link" />
}
